export default "__VITE_ASSET__CCf1bXal__"